import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FaArrowLeft,
  FaLink,
  FaCheckCircle,
  FaDollarSign,
  FaFileAlt,
  FaBoxOpen,
  FaHandshake,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaSearch,
  FaSitemap,
  FaShieldAlt,
  FaTruck,
  FaUsers,
  FaGlobe,
  FaAward,
  FaChartLine,
  FaIndustry,
  FaHome,
  FaLeaf,
  FaCogs,
  FaCircle
} from 'react-icons/fa';

// ============================================================
// LOCAL IMAGE IMPORTS
// ============================================================

import faiqLogo from '../logos/FaiqEnterprises/faiqenterpiseslogo.png';

import faiqImage1 from '../logos/FaiqEnterprises/faiqenterpises1.png';
import faiqImage2 from '../logos/FaiqEnterprises/faiqenterpises2.png';
import faiqImage3 from '../logos/FaiqEnterprises/faiqenterpises3.png';
import faiqImage4 from '../logos/FaiqEnterprises/faiqenterpises4.png';
import faiqImage5 from '../logos/FaiqEnterprises/faiqenterpises5.png';
import faiqImage6 from '../logos/FaiqEnterprises/faiqenterpises6.png';
import faiqImage7 from '../logos/FaiqEnterprises/faiqenterpises7.png';
import faiqImage8 from '../logos/FaiqEnterprises/faiqenterpises8.png';
import faiqImage9 from '../logos/FaiqEnterprises/faiqenterpises9.png';

// ============================================================
// COMPONENT
// ============================================================

export default function FaiqEnterprises() {
  const navigate = useNavigate();

  return (
    <div style={styles.pageBackground}>

      {/* ======================================================
          ANIMATION STYLES
      ====================================================== */}

      <style>{`

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(35px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeLeft {
          from {
            opacity: 0;
            transform: translateX(-40px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeRight {
          from {
            opacity: 0;
            transform: translateX(40px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes floatImage {
          0%, 100% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-8px);
          }
        }

        @keyframes pulseGold {
          0%, 100% {
            box-shadow: 0 0 0 rgba(217,119,6,0);
          }

          50% {
            box-shadow: 0 0 25px rgba(217,119,6,.25);
          }
        }

        @keyframes rotateSlow {
          from {
            transform: rotate(0deg);
          }

          to {
            transform: rotate(360deg);
          }
        }

        .faiq-animate-up {
          animation: fadeUp .9s ease both;
        }

        .faiq-animate-left {
          animation: fadeLeft .9s ease both;
        }

        .faiq-animate-right {
          animation: fadeRight .9s ease both;
        }

        .faiq-float {
          animation: floatImage 5s ease-in-out infinite;
        }

        .faiq-pulse {
          animation: pulseGold 3s ease-in-out infinite;
        }

        .faiq-card {
          transition:
            transform .35s ease,
            box-shadow .35s ease,
            border-color .35s ease;
        }

        .faiq-card:hover {
          transform: translateY(-7px);
          box-shadow: 0 18px 35px rgba(15,23,42,.14);
          border-color: #d97706 !important;
        }

        .faiq-image {
          transition:
            transform .5s ease,
            filter .5s ease;
        }

        .faiq-image:hover {
          transform: scale(1.06);
          filter: brightness(1.05);
        }

        .faiq-feature {
          transition:
            transform .3s ease,
            background-color .3s ease;
        }

        .faiq-feature:hover {
          transform: translateY(-5px);
          background-color: #fffaf0 !important;
        }

        .faiq-feature-icon {
          transition: transform .35s ease;
        }

        .faiq-feature:hover .faiq-feature-icon {
          transform: scale(1.18) rotate(5deg);
        }

        .faiq-process {
          transition: transform .3s ease;
        }

        .faiq-process:hover {
          transform: translateY(-6px);
        }

        .faiq-process-circle {
          transition:
            transform .4s ease,
            background-color .3s ease;
        }

        .faiq-process:hover .faiq-process-circle {
          transform: scale(1.12);
          background-color: #fff3cd !important;
        }

        .faiq-back-button {
          transition:
            transform .3s ease,
            background-color .3s ease,
            box-shadow .3s ease;
        }

        .faiq-back-button:hover {
          transform: translateX(-5px);
          background-color: #92400e !important;
          box-shadow: 0 8px 20px rgba(0,0,0,.2);
        }

        .faiq-contact {
          transition: transform .25s ease;
        }

        .faiq-contact:hover {
          transform: translateX(5px);
        }

        /* ======================================================
           LARGE DESKTOP
        ====================================================== */

        @media (min-width: 1500px) {

          .faiq-poster {
            max-width: 1500px !important;
          }

          .faiq-main-title {
            font-size: 76px !important;
          }

          .faiq-global-title {
            font-size: 43px !important;
          }

          .faiq-hero {
            min-height: 390px !important;
          }

        }

        /* ======================================================
           TABLET
        ====================================================== */

        @media (max-width: 1050px) {

          .faiq-poster {
            padding: 20px !important;
          }

          .faiq-header {
            grid-template-columns: 1fr !important;
          }

          .faiq-header-right {
            width: 100%;
          }

          .faiq-hero {
            min-height: 330px !important;
          }

          .faiq-products {
            grid-template-columns: repeat(3, 1fr) !important;
          }

          .faiq-mid {
            grid-template-columns: 1fr !important;
          }

          .faiq-bottom {
            grid-template-columns: 1fr !important;
          }

          .faiq-process-row {
            flex-wrap: wrap !important;
            gap: 25px !important;
            justify-content: center !important;
          }

          .faiq-process-arrow {
            display: none !important;
          }

          .faiq-cta {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 25px !important;
          }

          .faiq-cta-right {
            border-left: none !important;
            border-top: 1px solid #334155 !important;
            padding-left: 0 !important;
            padding-top: 15px !important;
            width: 100% !important;
          }

          .faiq-footer {
            flex-wrap: wrap !important;
            gap: 20px !important;
          }

        }

        /* ======================================================
           MOBILE
        ====================================================== */

        @media (max-width: 700px) {

          .faiq-page {
            padding: 8px !important;
          }

          .faiq-top-nav {
            margin-bottom: 10px !important;
          }

          .faiq-back-button {
            font-size: 12px !important;
            padding: 9px 12px !important;
          }

          .faiq-poster {
            padding: 12px !important;
            border-radius: 0 !important;
          }

          .faiq-header {
            gap: 18px !important;
            margin-bottom: 18px !important;
          }

          .faiq-logo {
            width: 180px !important;
            max-width: 70% !important;
          }

          .faiq-main-title {
            font-size: 45px !important;
          }

          .faiq-global-title {
            font-size: 28px !important;
          }

          .faiq-trusted {
            font-size: 10px !important;
          }

          .faiq-tagline {
            font-size: 9px !important;
          }

          .faiq-intro {
            font-size: 12px !important;
            line-height: 1.7 !important;
          }

          .faiq-hero {
            min-height: 250px !important;
            padding: 18px !important;
          }

          .faiq-hero-small {
            font-size: 11px !important;
          }

          .faiq-hero-big {
            font-size: 25px !important;
          }

          .faiq-hero-sub {
            font-size: 10px !important;
          }

          .faiq-badge {
            right: 8px !important;
            top: -8px !important;
          }

          .faiq-features {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 0 !important;
          }

          .faiq-feature {
            padding: 14px 8px !important;
            border-bottom: 1px solid #e2e8f0;
          }

          .faiq-feature-icon {
            font-size: 21px !important;
          }

          .faiq-feature-text {
            font-size: 8px !important;
          }

          .faiq-section-bar {
            font-size: 10px !important;
            padding: 11px 8px !important;
            letter-spacing: 1px !important;
          }

          .faiq-products {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 8px !important;
          }

          .faiq-product-card {
            padding: 8px !important;
          }

          .faiq-product-title {
            font-size: 9px !important;
          }

          .faiq-product-desc {
            font-size: 8px !important;
            min-height: auto !important;
          }

          .faiq-product-image {
            height: 75px !important;
          }

          .faiq-rice-types {
            grid-template-columns: repeat(2, 1fr) !important;
          }

          .faiq-rice-pills {
            flex-direction: column !important;
          }

          .faiq-rice-card,
          .faiq-global-card {
            padding: 15px !important;
          }

          .faiq-map {
            min-height: 180px !important;
          }

          .faiq-bottom {
            gap: 12px !important;
          }

          .faiq-why,
          .faiq-process-box {
            padding: 15px !important;
          }

          .faiq-process-row {
            display: grid !important;
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 22px 10px !important;
          }

          .faiq-process {
            max-width: none !important;
          }

          .faiq-process-title {
            font-size: 8px !important;
          }

          .faiq-process-sub {
            font-size: 7px !important;
          }

          .faiq-cta {
            padding: 18px 14px !important;
          }

          .faiq-cta-left {
            align-items: flex-start !important;
          }

          .faiq-cta-title {
            font-size: 13px !important;
          }

          .faiq-cta-sub {
            font-size: 10px !important;
          }

          .faiq-contact {
            font-size: 10px !important;
          }

          .faiq-footer {
            flex-direction: column !important;
            align-items: flex-start !important;
          }

          .faiq-footer-pillars {
            width: 100% !important;
            display: grid !important;
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 15px !important;
          }

          .faiq-footer-pillar {
            max-width: none !important;
          }

        }

        /* ======================================================
           SMALL MOBILE
        ====================================================== */

        @media (max-width: 420px) {

          .faiq-products {
            grid-template-columns: 1fr !important;
          }

          .faiq-product-image {
            height: 130px !important;
          }

          .faiq-process-row {
            grid-template-columns: 1fr !important;
          }

          .faiq-footer-pillars {
            grid-template-columns: 1fr 1fr !important;
          }

        }

      `}</style>

      {/* ======================================================
          TOP NAVIGATION
      ====================================================== */}

      <div
        className="faiq-top-nav"
        style={styles.topNav}
      >

        <button
          className="faiq-back-button"
          style={styles.backButton}
          onClick={() => navigate('/')}
        >
          <FaArrowLeft style={{ marginRight: '8px' }} />
          Back to All Sectors
        </button>

      </div>

      {/* ======================================================
          MAIN FULL WIDTH POSTER
      ====================================================== */}

      <div
        className="faiq-poster"
        style={styles.posterCard}
      >

        {/* ====================================================
            HEADER
        ==================================================== */}

        <section
          className="faiq-header"
          style={styles.headerGrid}
        >

          {/* LEFT */}

          <div
            className="faiq-animate-left"
            style={styles.headerLeft}
          >

            <img
              className="faiq-logo"
              src={faiqLogo}
              alt="Enterprises"
              style={styles.logo}
            />

            <div style={styles.mainTitleBox}>

              <h1
                className="faiq-main-title"
                style={styles.mainTitle}
              >
               
              </h1>

              <div style={styles.subtitleDash}>
                — ENTERPRISES —
              </div>

            </div>

            <div
              className="faiq-trusted"
              style={styles.trustedPartnerHeading}
            >
              YOUR TRUSTED PARTNER IN
            </div>

            <div
              className="faiq-global-title"
              style={styles.globalSourcingTitle}
            >

              <span style={styles.textGold}>
                GLOBAL SOURCING
              </span>

              <br />

              <span style={styles.textNavy}>
                &amp; EXPORT
              </span>

            </div>

            <div
              className="faiq-tagline"
              style={styles.tagline}
            >
              SOURCING. SUPPLYING. DELIVERING EXCELLENCE.
            </div>

            <p
              className="faiq-intro"
              style={styles.introDesc}
            >
              Faiq Enterprises is the sourcing and export arm of
              Ashraf Group of Industries, connecting global markets
              with the finest products manufactured in Gujranwala —
              one of Pakistan's most diverse industrial hubs.
            </p>

          </div>

          {/* RIGHT */}

          <div
            className="faiq-header-right faiq-animate-right"
            style={styles.headerRight}
          >

            <div
              className="faiq-badge faiq-pulse"
              style={styles.proudlyMadeBadge}
            >

              <div style={styles.proudlyMadeTextTop}>
                PROUDLY
              </div>

              <div style={styles.proudlyMadeTextMid}>
                MADE IN
              </div>

              <div style={styles.proudlyMadeTextBot}>
                GUJRANWALA
              </div>

              <div style={styles.badgeBuildingIcon}>
                🏛️
              </div>

            </div>

            <div
              className="faiq-hero faiq-float"
              style={{
                ...styles.heroImageContainer,
                backgroundImage:
                  `linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.55)),url(${faiqImage1})`
              }}
            >

              <div style={styles.heroImageOverlayTitle}>

                <span
                  className="faiq-hero-small"
                  style={styles.heroTopSmall}
                >
                  FROM GUJRANWALA
                </span>

                <span
                  className="faiq-hero-big"
                  style={styles.heroTopBig}
                >
                  TO THE WORLD
                </span>

                <span
                  className="faiq-hero-sub"
                  style={styles.heroSubText}
                >
                  Complete Sourcing &amp; Export Solutions
                </span>

              </div>

            </div>

          </div>

        </section>

        {/* ====================================================
            FEATURES
        ==================================================== */}

        <div
          className="faiq-features faiq-animate-up"
          style={styles.featuresBanner}
        >

          <Feature
            icon={<FaLink />}
            text={<>END-TO-END<br />SOURCING</>}
          />

          <Feature
            icon={<FaCheckCircle />}
            text={<>QUALITY<br />INSPECTION</>}
          />

          <Feature
            icon={<FaDollarSign />}
            text={<>COMPETITIVE<br />PRICING</>}
          />

          <Feature
            icon={<FaFileAlt />}
            text={<>EXPORT<br />DOCUMENTATION</>}
          />

          <Feature
            icon={<FaBoxOpen />}
            text={<>CUSTOMIZED<br />PACKAGING</>}
          />

          <Feature
            icon={<FaHandshake />}
            text={<>RELIABLE<br />PARTNERSHIP</>}
          />

        </div>

        {/* ====================================================
            PRODUCTS HEADER
        ==================================================== */}

        <div
          className="faiq-section-bar"
          style={styles.sectionHeaderBar}
        >
          WE EXPORT EVERYTHING MADE IN GUJRANWALA
        </div>

        {/* ====================================================
            PRODUCT CATEGORIES
        ==================================================== */}

        <div
          className="faiq-products"
          style={styles.productCategoriesGrid}
        >

          <ProductCard
            icon={<FaLeaf />}
            title="FOOD PRODUCTS"
            desc={
              <>
                Rice (Basmati, IRRI, 1121)<br />
                Pulses, Flour, Spices,<br />
                Dried Fruits &amp; More
              </>
            }
            image1={faiqImage2}
            image2={faiqImage3}
          />

          <ProductCard
            icon={<FaCogs />}
            title="TEXTILES"
            desc={
              <>
                Fabrics, Towels,<br />
                Bed Linen, Garments<br />
                &amp; Made-ups
              </>
            }
            image1={faiqImage4}
            image2={faiqImage5}
          />

          <ProductCard
            icon={<FaHome />}
            title="CARPETS & MATS"
            desc={
              <>
                Tufted Carpets,<br />
                Prayer Mats,<br />
                PVC &amp; Rubber Mats
              </>
            }
            image1={faiqImage6}
            image2={faiqImage7}
          />

          <ProductCard
            icon={<FaIndustry />}
            title="INDUSTRIAL PRODUCTS"
            desc={
              <>
                Rubber Goods, PVC Products,<br />
                Mats, Machinery Parts<br />
                &amp; Components
              </>
            }
            image1={faiqImage8}
            image2={faiqImage9}
          />

          <ProductCard
            icon={<FaCircle />}
            title="YARN & FIBERS"
            desc={
              <>
                Viscose Yarn,<br />
                Jute Yarn &amp; Other<br />
                Synthetic Yarns
              </>
            }
            image1={faiqImage5}
            image2={faiqImage8}
          />

          <ProductCard
            icon={<FaHome />}
            title="HOME & LIFESTYLE"
            desc={
              <>
                Home Décor, Handicrafts,<br />
                Household Items,<br />
                Furniture &amp; More
              </>
            }
            image1={faiqImage6}
            image2={faiqImage9}
          />

        </div>

        {/* ====================================================
            RICE + GLOBAL REACH
        ==================================================== */}

        <div
          className="faiq-mid"
          style={styles.midSplitGrid}
        >

          {/* RICE */}

          <div
            className="faiq-rice-card faiq-card"
            style={styles.riceExportCard}
          >

            <div style={styles.riceCardContent}>

              <div style={styles.riceHeaderTitle}>
                SPECIALIZATION IN RICE EXPORT
              </div>

              <div style={styles.riceSubTitle}>
                Premium quality. Authentic taste. Global trust.
              </div>

              <div
                className="faiq-rice-types"
                style={styles.riceTypesRow}
              >

                <RiceType title={<>PREMIUM<br />BASMATI</>} />

                <RiceType title={<>1121<br />LONG GRAIN</>} />

                <RiceType title={<>IRRI<br />VARIETIES</>} />

                <RiceType title={<>SELLA &amp;<br />STEAM RICE</>} />

              </div>

              <div
                className="faiq-rice-pills"
                style={styles.ricePillsRow}
              >

                <span>✓ Carefully Sourced</span>
                <span>✓ Hygienically Processed</span>
                <span>✓ Quality Assured</span>
                <span>✓ Export Ready</span>

              </div>

            </div>

          </div>

          {/* GLOBAL REACH */}

          <div
            className="faiq-global-card faiq-card"
            style={styles.globalReachCard}
          >

            <div style={styles.globalReachHeader}>
              GLOBAL REACH
            </div>

            <div style={styles.globalReachSub}>
              Delivering quality products to satisfied customers
              across the globe.
            </div>

            <div
              className="faiq-map"
              style={styles.mapVisualBox}
            >

              <div style={styles.mapPlaceholderImg}>

                <div style={styles.mapGlobe}>
                  <FaGlobe />
                </div>

                <div style={styles.globePinList}>

                  <Pin text="MIDDLE EAST" />
                  <Pin text="AFRICA" />
                  <Pin text="EUROPE" />
                  <Pin text="NORTH AMERICA" />
                  <Pin text="AND BEYOND" />

                </div>

              </div>

            </div>

          </div>

        </div>

        {/* ====================================================
            WHY US + PROCESS
        ==================================================== */}

        <div
          className="faiq-bottom"
          style={styles.bottomSplitGrid}
        >

          {/* WHY */}

          <div
            className="faiq-why faiq-card"
            style={styles.whyBox}
          >

            <div style={styles.infoBoxTitle}>
              WHY WORK WITH FAIQ ENTERPRISES?
            </div>

            <ul style={styles.checkList}>

              <Check text="Deep local market knowledge & strong supplier network" />

              <Check text="Mixed container & full container load expertise" />

              <Check text="Reliable logistics partners & timely deliveries" />

              <Check text="Strict quality control & inspection process" />

              <Check text="Customized solutions to meet every buyer's needs" />

              <Check text="Long-term relationships built on trust & transparency" />

            </ul>

            <div style={styles.warehouseImagePreview}>

              <img
                className="faiq-image"
                src={faiqImage1}
                alt="Warehouse Operations"
                style={styles.whImg}
              />

            </div>

          </div>

          {/* PROCESS */}

          <div
            className="faiq-process-box faiq-card"
            style={styles.processBox}
          >

            <div style={styles.infoBoxTitle}>
              OUR SIMPLE &amp; EFFICIENT PROCESS
            </div>

            <div
              className="faiq-process-row"
              style={styles.processStepsRow}
            >

              <Process
                icon={<FaSearch />}
                title="REQUIREMENT ANALYSIS"
                sub="Understanding your needs"
              />

              <span
                className="faiq-process-arrow"
                style={styles.processArrow}
              >
                →
              </span>

              <Process
                icon={<FaSitemap />}
                title="SOURCING & SELECTION"
                sub="From trusted manufacturers"
              />

              <span
                className="faiq-process-arrow"
                style={styles.processArrow}
              >
                →
              </span>

              <Process
                icon={<FaShieldAlt />}
                title="QUALITY CHECK & INSPECTION"
                sub="Ensuring the best quality"
              />

              <span
                className="faiq-process-arrow"
                style={styles.processArrow}
              >
                →
              </span>

              <Process
                icon={<FaTruck />}
                title="PACKAGING & SHIPPING"
                sub="Safe, secure & on time delivery"
              />

              <span
                className="faiq-process-arrow"
                style={styles.processArrow}
              >
                →
              </span>

              <Process
                icon={<FaUsers />}
                title="AFTER SALES SUPPORT"
                sub="Building long-term partnerships"
              />

            </div>

          </div>

        </div>

        {/* ====================================================
            CTA
        ==================================================== */}

        <div
          className="faiq-cta"
          style={styles.ctaBanner}
        >

          <div
            className="faiq-cta-left"
            style={styles.ctaLeft}
          >

            <div style={styles.ctaIconCircle}>
              <FaHandshake />
            </div>

            <div>

              <div
                className="faiq-cta-title"
                style={styles.ctaTitle}
              >
                LET'S BUILD SUCCESS TOGETHER
              </div>

              <div
                className="faiq-cta-sub"
                style={styles.ctaSub}
              >
                Partner with Faiq Enterprises for seamless
                sourcing and export solutions. We handle the
                rest, so you can focus on growing your business.
              </div>

            </div>

          </div>

          <div
            className="faiq-cta-right"
            style={styles.ctaRight}
          >

            <div
              className="faiq-contact"
              style={styles.contactLine}
            >
              <FaPhoneAlt style={styles.contactIcon} />
              +923454545333
            </div>

            <div
              className="faiq-contact"
              style={styles.contactLine}
            >
              <FaEnvelope style={styles.contactIcon} />
              Faiq.kaleem@gmail.com
            </div>

            <div
              className="faiq-contact"
              style={styles.contactLine}
            >
              <FaMapMarkerAlt style={styles.contactIcon} />
              Gujranwala, Pakistan
            </div>

          </div>

        </div>

        {/* ====================================================
            FOOTER
        ==================================================== */}

        <footer
          className="faiq-footer"
          style={styles.footer}
        >

          <div style={styles.footerBadge}>
            18
          </div>

          <div style={styles.footerCompanyInfo}>

            <strong style={styles.footerCompanyName}>
              ASHRAF GROUP OF INDUSTRIES
            </strong>

            <span style={styles.footerCompanyTagline}>
              Building Legacy. Powering the Future.
            </span>

          </div>

          <div
            className="faiq-footer-pillars"
            style={styles.footerPillarsRow}
          >

            <FooterPillar
              icon={<FaBuildingIcon />}
              text="DIVERSE PORTFOLIO"
            />

            <FooterPillar
              icon={<FaGlobe />}
              text="GLOBAL PRESENCE"
            />

            <FooterPillar
              icon={<FaAward />}
              text="TRUSTED EXCELLENCE"
            />

            <FooterPillar
              icon={<FaTruck />}
              text="DELIVERING VALUE"
            />

            <FooterPillar
              icon={<FaChartLine />}
              text="GROWING TOGETHER"
            />

          </div>

        </footer>

      </div>

    </div>
  );
}

// ============================================================
// SMALL COMPONENTS
// ============================================================

function Feature({ icon, text }) {
  return (
    <div
      className="faiq-feature"
      style={styles.featureItem}
    >

      <div
        className="faiq-feature-icon"
        style={styles.featureIcon}
      >
        {icon}
      </div>

      <span
        className="faiq-feature-text"
        style={styles.featureText}
      >
        {text}
      </span>

    </div>
  );
}

function ProductCard({
  icon,
  title,
  desc,
  image1,
  image2
}) {
  return (
    <div
      className="faiq-product-card faiq-card"
      style={styles.prodCatCard}
    >

      <div style={styles.prodCatHeader}>

        <span style={styles.prodCatIconSymbol}>
          {icon}
        </span>

        <span
          className="faiq-product-title"
          style={styles.prodCatTitle}
        >
          {title}
        </span>

      </div>

      <p
        className="faiq-product-desc"
        style={styles.prodCatDesc}
      >
        {desc}
      </p>

      <div style={styles.prodCatThumbRow}>

        <img
          className="faiq-image faiq-product-image"
          src={image1}
          alt={title}
          style={styles.prodThumb}
        />

        <img
          className="faiq-image faiq-product-image"
          src={image2}
          alt={title}
          style={styles.prodThumb}
        />

      </div>

    </div>
  );
}

function RiceType({ title }) {
  return (
    <div style={styles.riceTypeBadge}>

      <div style={styles.riceTypeCircle}>
        🌾
      </div>

      <span>
        {title}
      </span>

    </div>
  );
}

function Pin({ text }) {
  return (
    <div style={styles.pinItem}>

      <FaMapMarkerAlt
        style={{
          color: '#d97706',
          flexShrink: 0
        }}
      />

      {text}

    </div>
  );
}

function Check({ text }) {
  return (
    <li style={styles.checkListItem}>

      <FaCheckCircle style={styles.checkIcon} />

      <span>
        {text}
      </span>

    </li>
  );
}

function Process({
  icon,
  title,
  sub
}) {
  return (
    <div
      className="faiq-process"
      style={styles.processStep}
    >

      <div
        className="faiq-process-circle"
        style={styles.processIconCircle}
      >
        {icon}
      </div>

      <span
        className="faiq-process-title"
        style={styles.processStepTitle}
      >
        {title}
      </span>

      <span
        className="faiq-process-sub"
        style={styles.processStepSub}
      >
        {sub}
      </span>

    </div>
  );
}

function FooterPillar({
  icon,
  text
}) {
  return (
    <div
      className="faiq-footer-pillar"
      style={styles.footerPillarItem}
    >

      <div style={styles.footerPillarIcon}>
        {icon}
      </div>

      <span>
        {text}
      </span>

    </div>
  );
}

function FaBuildingIcon() {
  return <FaIndustry />;
}

// ============================================================
// STYLES
// ============================================================

const styles = {

  pageBackground: {
    backgroundColor: '#07111f',
    minHeight: '100vh',
    padding: '20px 12px',
    fontFamily: 'Arial, Helvetica, sans-serif',
    color: '#333333',
    boxSizing: 'border-box'
  },

  topNav: {
    width: '100%',
    maxWidth: '1500px',
    margin: '0 auto 15px auto'
  },

  backButton: {
    backgroundColor: '#b45309',
    color: '#ffffff',
    border: 'none',
    padding: '11px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: '13px',
    fontFamily: 'Arial, sans-serif'
  },

  posterCard: {
    width: '100%',
    maxWidth: '1500px',
    margin: '0 auto',
    backgroundColor: '#ffffff',
    boxShadow: '0 20px 50px rgba(0,0,0,.55)',
    border: '1px solid #d97706',
    overflow: 'hidden',
    padding: '30px',
    boxSizing: 'border-box'
  },

  /* HEADER */

  headerGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1.2fr',
    gap: '35px',
    marginBottom: '30px',
    alignItems: 'center'
  },

  headerLeft: {
    display: 'flex',
    flexDirection: 'column'
  },

  logo: {
    width: '250px',
    maxWidth: '100%',
    height: 'auto',
    objectFit: 'contain',
    marginBottom: '12px'
  },

  mainTitleBox: {
    marginBottom: '12px'
  },

  mainTitle: {
    margin: 0,
    fontSize: '65px',
    fontWeight: '900',
    color: '#0f172a',
    letterSpacing: '1px',
    lineHeight: '1'
  },

  subtitleDash: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#78350f',
    letterSpacing: '4px',
    marginTop: '5px'
  },

  trustedPartnerHeading: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#475569',
    letterSpacing: '1.5px',
    marginBottom: '5px'
  },

  globalSourcingTitle: {
    fontSize: '38px',
    fontWeight: '900',
    lineHeight: '1.05',
    marginBottom: '14px'
  },

  textGold: {
    color: '#d97706'
  },

  textNavy: {
    color: '#0f172a'
  },

  tagline: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#92400e',
    letterSpacing: '.7px',
    marginBottom: '14px'
  },

  introDesc: {
    fontSize: '13px',
    color: '#475569',
    lineHeight: '1.7',
    margin: 0,
    maxWidth: '650px'
  },

  headerRight: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch'
  },

  proudlyMadeBadge: {
    position: 'absolute',
    top: '-12px',
    right: '20px',
    backgroundColor: '#0f172a',
    color: '#ffffff',
    padding: '12px 15px',
    borderRadius: '0 0 10px 10px',
    textAlign: 'center',
    zIndex: 10,
    boxShadow: '0 5px 15px rgba(0,0,0,.3)',
    border: '2px solid #fbbf24',
    borderTop: 'none'
  },

  proudlyMadeTextTop: {
    fontSize: '9px',
    fontWeight: 'bold',
    letterSpacing: '1px'
  },

  proudlyMadeTextMid: {
    fontSize: '13px',
    fontWeight: '900',
    color: '#fbbf24'
  },

  proudlyMadeTextBot: {
    fontSize: '9px',
    fontWeight: 'bold',
    letterSpacing: '.5px'
  },

  badgeBuildingIcon: {
    fontSize: '20px',
    marginTop: '3px'
  },

  heroImageContainer: {
    width: '100%',
    minHeight: '350px',
    borderRadius: '10px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    padding: '28px',
    boxSizing: 'border-box',
    boxShadow: '0 12px 30px rgba(0,0,0,.25)',
    border: '2px solid #d97706'
  },

  heroImageOverlayTitle: {
    display: 'flex',
    flexDirection: 'column'
  },

  heroTopSmall: {
    fontSize: '15px',
    color: '#fef3c7',
    fontWeight: 'bold',
    letterSpacing: '1.5px'
  },

  heroTopBig: {
    fontSize: '40px',
    color: '#ffffff',
    fontWeight: '900',
    lineHeight: '1.05',
    marginBottom: '5px'
  },

  heroSubText: {
    fontSize: '13px',
    color: '#e2e8f0'
  },

  /* FEATURES */

  featuresBanner: {
    backgroundColor: '#f8fafc',
    borderRadius: '7px',
    padding: '8px',
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 1fr)',
    gap: '0',
    marginBottom: '28px',
    border: '1px solid #e2e8f0',
    overflow: 'hidden'
  },

  featureItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#0f172a',
    padding: '15px 8px',
    borderRight: '1px solid #e2e8f0'
  },

  featureIcon: {
    fontSize: '24px',
    color: '#b45309',
    marginBottom: '8px'
  },

  featureText: {
    fontSize: '10px',
    fontWeight: 'bold',
    lineHeight: '1.25',
    letterSpacing: '.4px'
  },

  /* SECTION */

  sectionHeaderBar: {
    backgroundColor: '#0f172a',
    color: '#ffffff',
    textAlign: 'center',
    padding: '12px',
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '2px',
    borderRadius: '5px',
    marginBottom: '18px',
    borderLeft: '5px solid #fbbf24'
  },

  /* PRODUCTS */

  productCategoriesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 1fr)',
    gap: '14px',
    marginBottom: '30px'
  },

  prodCatCard: {
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 3px 10px rgba(0,0,0,.04)',
    minWidth: 0
  },

  prodCatHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    marginBottom: '8px',
    borderBottom: '1px solid #f1f5f9',
    paddingBottom: '8px'
  },

  prodCatIconSymbol: {
    fontSize: '18px',
    color: '#b45309',
    flexShrink: 0
  },

  prodCatTitle: {
    fontSize: '11px',
    fontWeight: '900',
    color: '#0f172a'
  },

  prodCatDesc: {
    fontSize: '9px',
    color: '#475569',
    lineHeight: '1.45',
    margin: '0 0 10px 0',
    minHeight: '55px'
  },

  prodCatThumbRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '5px',
    marginTop: 'auto'
  },

  prodThumb: {
    width: '100%',
    height: '75px',
    borderRadius: '5px',
    objectFit: 'cover',
    border: '1px solid #e2e8f0'
  },

  /* MID */

  midSplitGrid: {
    display: 'grid',
    gridTemplateColumns: '1.1fr 1fr',
    gap: '22px',
    marginBottom: '28px'
  },

  riceExportCard: {
    background: 'linear-gradient(135deg,#0f172a,#1e293b)',
    borderRadius: '8px',
    padding: '25px',
    color: '#ffffff',
    border: '1px solid #334155',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },

  riceCardContent: {
    display: 'flex',
    flexDirection: 'column'
  },

  riceHeaderTitle: {
    fontSize: '17px',
    fontWeight: '900',
    color: '#fbbf24',
    letterSpacing: '1px',
    marginBottom: '5px'
  },

  riceSubTitle: {
    fontSize: '11px',
    color: '#cbd5e1',
    fontStyle: 'italic',
    marginBottom: '18px'
  },

  riceTypesRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4,1fr)',
    gap: '10px',
    marginBottom: '18px'
  },

  riceTypeBadge: {
    backgroundColor: 'rgba(255,255,255,.07)',
    border: '1px solid rgba(255,255,255,.15)',
    borderRadius: '6px',
    padding: '12px 5px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '9px',
    fontWeight: 'bold',
    color: '#fef3c7'
  },

  riceTypeCircle: {
    fontSize: '18px',
    marginBottom: '5px'
  },

  ricePillsRow: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    fontSize: '9px',
    color: '#cbd5e1'
  },

  globalReachCard: {
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    padding: '22px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 3px 10px rgba(0,0,0,.04)'
  },

  globalReachHeader: {
    fontSize: '17px',
    fontWeight: '900',
    color: '#0f172a',
    letterSpacing: '1px',
    marginBottom: '5px'
  },

  globalReachSub: {
    fontSize: '11px',
    color: '#475569',
    marginBottom: '15px',
    lineHeight: '1.5'
  },

  mapVisualBox: {
    background:
      'linear-gradient(135deg,#f8fafc,#fffaf0)',
    borderRadius: '7px',
    border: '1px solid #e2e8f0',
    padding: '18px',
    flex: '1',
    minHeight: '220px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  mapPlaceholderImg: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '25px'
  },

  mapGlobe: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    backgroundColor: '#0f172a',
    color: '#fbbf24',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '45px',
    flexShrink: 0,
    animation: 'rotateSlow 18s linear infinite'
  },

  globePinList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '7px',
    width: '100%',
    maxWidth: '220px'
  },

  pinItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '10px',
    fontWeight: 'bold',
    color: '#334155',
    backgroundColor: '#ffffff',
    padding: '6px 9px',
    borderRadius: '5px',
    border: '1px solid #e2e8f0'
  },

  /* BOTTOM */

  bottomSplitGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1.3fr',
    gap: '22px',
    marginBottom: '25px'
  },

  whyBox: {
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    padding: '22px',
    boxShadow: '0 3px 10px rgba(0,0,0,.04)',
    display: 'flex',
    flexDirection: 'column'
  },

  infoBoxTitle: {
    fontSize: '13px',
    fontWeight: '900',
    color: '#78350f',
    letterSpacing: '1px',
    marginBottom: '15px',
    borderBottom: '2px solid #fef3c7',
    paddingBottom: '6px'
  },

  checkList: {
    listStyle: 'none',
    padding: 0,
    margin: '0 0 15px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '9px'
  },

  checkListItem: {
    display: 'flex',
    alignItems: 'flex-start',
    fontSize: '10px',
    lineHeight: '1.4',
    color: '#334155'
  },

  checkIcon: {
    color: '#b45309',
    fontSize: '11px',
    marginRight: '8px',
    marginTop: '2px',
    flexShrink: 0
  },

  warehouseImagePreview: {
    height: '150px',
    borderRadius: '6px',
    overflow: 'hidden',
    marginTop: 'auto',
    border: '1px solid #e2e8f0'
  },

  whImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },

  processBox: {
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    padding: '22px',
    boxShadow: '0 3px 10px rgba(0,0,0,.04)',
    display: 'flex',
    flexDirection: 'column'
  },

  processStepsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '20px 0'
  },

  processStep: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '105px'
  },

  processIconCircle: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#fff7df',
    color: '#b45309',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '17px',
    marginBottom: '8px',
    border: '1px solid #fde68a'
  },

  processStepTitle: {
    fontSize: '8px',
    fontWeight: 'bold',
    color: '#0f172a',
    lineHeight: '1.25',
    marginBottom: '3px'
  },

  processStepSub: {
    fontSize: '7px',
    color: '#64748b',
    lineHeight: '1.2'
  },

  processArrow: {
    fontSize: '20px',
    color: '#d97706',
    fontWeight: 'bold',
    marginBottom: '25px'
  },

  /* CTA */

  ctaBanner: {
    backgroundColor: '#0f172a',
    borderRadius: '8px',
    padding: '22px 25px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '25px',
    border: '1px solid #334155'
  },

  ctaLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    maxWidth: '700px'
  },

  ctaIconCircle: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: '#b45309',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    flexShrink: 0,
    border: '2px solid #fbbf24'
  },

  ctaTitle: {
    fontSize: '15px',
    fontWeight: '900',
    color: '#fbbf24',
    letterSpacing: '1px',
    marginBottom: '5px'
  },

  ctaSub: {
    fontSize: '10px',
    color: '#cbd5e1',
    lineHeight: '1.5'
  },

  ctaRight: {
    display: 'flex',
    flexDirection: 'column',
    gap: '7px',
    borderLeft: '1px solid #334155',
    paddingLeft: '25px'
  },

  contactLine: {
    fontSize: '10px',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold'
  },

  contactIcon: {
    color: '#fbbf24',
    marginRight: '8px'
  },

  /* FOOTER */

  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '25px',
    borderTop: '2px solid #b45309',
    paddingTop: '15px'
  },

  footerBadge: {
    backgroundColor: '#b45309',
    color: '#ffffff',
    fontSize: '28px',
    fontWeight: '900',
    padding: '7px 18px',
    borderRadius: '3px'
  },

  footerCompanyInfo: {
    display: 'flex',
    flexDirection: 'column'
  },

  footerCompanyName: {
    fontSize: '14px',
    color: '#b45309',
    letterSpacing: '.5px'
  },

  footerCompanyTagline: {
    fontSize: '10px',
    color: '#475569',
    fontStyle: 'italic'
  },

  footerPillarsRow: {
    display: 'flex',
    gap: '18px'
  },

  footerPillarItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: '8px',
    fontWeight: 'bold',
    color: '#334155',
    lineHeight: '1.2',
    maxWidth: '90px'
  },

  footerPillarIcon: {
    fontSize: '17px',
    color: '#b45309',
    marginBottom: '4px'
  }

};